import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "m-auto" }
const _hoisted_2 = { class: "rounded py-[12px] px-[24px] w-full bg-theme-grey" }
const _hoisted_3 = { class: "flex justify-between py-3" }
const _hoisted_4 = { class: "font-normal text-base text-[#9E9E9E]" }
const _hoisted_5 = { class: "font-normal text-base text-[#9E9E9E]" }
const _hoisted_6 = { class: "relative w-full mx-auto mt-4 mb-8" }
const _hoisted_7 = { class: "overflow-y-auto select-business-block overflow-hidden" }
const _hoisted_8 = { class: "grid gap-4 lg:grid-cols-5 xl:grid-cols-6 sm:grid-cols-3 grid-cols-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "h-[90px] overflow-hidden bg-theme-grey-light w-full" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex flex-col justify-between" }
const _hoisted_15 = { class: "flex items-center cursor-pointer" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = {
  key: 2,
  class: "content-center text-white"
}
const _hoisted_18 = { class: "flex justify-center py-6" }
const _hoisted_19 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_ToggleBusinessStatusModal = _resolveComponent("ToggleBusinessStatusModal")!
  const _component_Base = _resolveComponent("Base")!

  return (_openBlock(), _createBlock(_component_Base, null, {
    basecontent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.currentDate()), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.timestamp()), 1)
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hello mb-5 text-center text-white text-lg" }, "Select which business you would like to access or create a new one!", -1)),
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none" }, [
                    _createElementVNode("svg", {
                      "aria-hidden": "true",
                      class: "w-5 h-5 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      })
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchtext) = $event)),
                    type: "search",
                    id: "product-search",
                    class: "block p-2 pl-10 w-full bg-[#464851] text-white rounded-md focus:outline-none",
                    placeholder: "Search businesses"
                  }, null, 512), [
                    [_vModelText, _ctx.searchtext]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (_ctx.vg_loggedInUser.userType == 'super')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.addBusiness()), ["prevent"])),
                          class: "bg-[#464851] hover:bg-theme-darkgreen mb-4 mx-2 py-4 px-2 text-center text-white cursor-pointer select-none rounded-lg w-[200px]"
                        }, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("div", {
                            class: "text-9xl text-[#878686] mb-2",
                            style: {"line-height":"0.7"}
                          }, "+", -1),
                          _createElementVNode("span", { class: "uppercase" }, "New Business", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (_ctx.filteredBusinesses.length>0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredBusinesses, (business) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: business.id,
                            onClick: ($event: any) => (_ctx.selectBusiness(business)),
                            class: _normalizeClass([_ctx.selectedBusiness.id==business.id?'bg-theme-darkgreen':'', "bg-[#464851] mx-2 mb-4 py-4 px-6 hover:bg-theme-darkgreen text-center text-white cursor-pointer select-none rounded-lg w-[200px]"])
                          }, [
                            _createElementVNode("div", null, [
                              _createElementVNode("figure", _hoisted_10, [
                                (business.branding && business.branding.logo)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      src: business.branding.logo,
                                      alt: "",
                                      class: "object-contain text-center h-full mx-auto"
                                    }, null, 8, _hoisted_11))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(business.name), 1)
                            ]),
                            _createElementVNode("div", {
                              class: "business-activity mt-5",
                              onClick: _withModifiers(($event: any) => (_ctx.showToggleBusinessModal(business)), ["prevent"])
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("label", _hoisted_15, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((business.status) = $event),
                                    class: "hidden peer"
                                  }, null, 8, _hoisted_16), [
                                    [_vModelCheckbox, business.status]
                                  ]),
                                  _createElementVNode("div", {
                                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (business.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                                  }, null, 2),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", business.status ? 'text-theme-green' : 'text-[#F53333]'])
                                  }, _toDisplayString(business.status ? 'On' : 'Off'), 3)
                                ])
                              ])
                            ], 8, _hoisted_13)
                          ], 10, _hoisted_9))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, " No business found "))
                  ])
                ])
              ], 64)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmBusiness())),
              disabled: !_ctx.selectedBusiness || !_ctx.selectedBusiness.id,
              class: "disabled:bg-theme-modalbg flex justify-center items-center hover:opacity-70 w-[323px] h-[44px] px-4 py-2 rounded bg-[#2BA66B] font-bold text-base text-white leading-5 tracking-[0.15px]"
            }, "CONFIRM", 8, _hoisted_19)
          ])
        ])
      ]),
      (_ctx.toggleBusinessStatus.modal)
        ? (_openBlock(), _createBlock(_component_ToggleBusinessStatusModal, {
            key: 0,
            callback: _ctx.closeToggleBusinessModal,
            business: _ctx.toggleBusinessStatus.business
          }, null, 8, ["callback", "business"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}